import { combineReducers } from 'redux';
import { connectRouter, RouterState } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import organizationReducer from '../contexts/OrganizationsContext/reducer';
import spotsReducer from './spots.reducers';
import reportsReducer from './reports.reducers';
import authReducer from './auth.reducers';
import dashboardReducer from './dashboard.reducers';

const history = createBrowserHistory();

export type AppState = {
    router: RouterState;
    auth: ReturnType<typeof authReducer>;
    organization: ReturnType<typeof organizationReducer>;
    spots: ReturnType<typeof spotsReducer>;
    reports: ReturnType<typeof reportsReducer>;
    dashboard: ReturnType<typeof dashboardReducer>;
};

const appReducer = combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    organization: organizationReducer,
    spots: spotsReducer,
    reports: reportsReducer,
    dashboard: dashboardReducer,
});

const rootReducer = (state: AppState | undefined, action: any): AppState => {
    return appReducer(state, action);
};

export default rootReducer;
